/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_ReviewInputs */

const en_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Review`)
};

const es_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En revisión`)
};

const fr_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours d'examen`)
};

const de_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Prüfung`)
};

const ja_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`審査中`)
};

const zh_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核中`)
};

const ar_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيد المراجعة`)
};

const id_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam Peninjauan`)
};

const it_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Revisione`)
};

const ru_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На модерации`)
};

const pt_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em Análise`)
};

const ko_listing_status_review = /** @type {(inputs: Listing_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검토 중`)
};

/**
* | output |
* | --- |
* | "In Review" |
*
* @param {Listing_Status_ReviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_review = /** @type {((inputs?: Listing_Status_ReviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_ReviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_review(inputs)
	if (locale === "es") return es_listing_status_review(inputs)
	if (locale === "fr") return fr_listing_status_review(inputs)
	if (locale === "de") return de_listing_status_review(inputs)
	if (locale === "ja") return ja_listing_status_review(inputs)
	if (locale === "zh") return zh_listing_status_review(inputs)
	if (locale === "ar") return ar_listing_status_review(inputs)
	if (locale === "id") return id_listing_status_review(inputs)
	if (locale === "it") return it_listing_status_review(inputs)
	if (locale === "ru") return ru_listing_status_review(inputs)
	if (locale === "pt") return pt_listing_status_review(inputs)
	return ko_listing_status_review(inputs)
});